// extracted by mini-css-extract-plugin
export default {"wrapper":"packs-list_wrapper__4ZxbU","listReveal":"packs-list_listReveal__MoK16"};